"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var RoundedProductPriceRequired_1 = require("./RoundedProductPriceRequired");
/**
 * <p>The simplest representation of the price with a certain, potentially open, validity.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var PriceWithValidity =
/*#__PURE__*/
function (_RoundedProductPriceR) {
  _inherits(PriceWithValidity, _RoundedProductPriceR);

  /**
   * Ctor.
   *
   * @param value The value of price. Corresponds to {@link RoundedProductPriceRequired.value}.
   * @param valueRounded The potentially rounded price. Corresponds to {@link RoundedProductPriceRequired.valueRounded}.
   * @param validFrom The start of validity of the price.
   * @param validTo The end of validity of the price. Null means that the price should be valid to the infinity.
   */
  function PriceWithValidity(value, valueRounded, validFrom, validTo) {
    var _this;

    _classCallCheck(this, PriceWithValidity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceWithValidity).call(this, value, valueRounded));
    _this.value = value;
    _this.valueRounded = valueRounded;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }
  /**
   * Returns true if a given price validity overlaps with a current price validity.
   */


  _createClass(PriceWithValidity, [{
    key: "overlapsWith",
    value: function overlapsWith(price) {
      return (!price.validTo || this.validFrom.isBefore(price.validTo)) && (!this.validTo || this.validTo.isAfter(price.validFrom));
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceWithValidity(mat.value, mat.valueRounded, mat.validFrom, mat.validTo);
    }
  }]);

  return PriceWithValidity;
}(RoundedProductPriceRequired_1.RoundedProductPriceRequired);

exports.PriceWithValidity = PriceWithValidity;

PriceWithValidity.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceWithValidity.name);
  return {
    value: builder.bigNum('value'),
    valueRounded: builder.opt(builder.bigNum('valueRounded')),
    validTo: builder.opt(builder.date('validTo')),
    validFrom: builder.date('validFrom')
  };
}();